import ValidationError from "../../validationError";
import ObjectModelEntry from "../objectModelEntry";
import Vue from "vue";

export abstract class BaseObjectModelEntryValidator {
  entry: ObjectModelEntry;
  validators: BaseObjectModelEntryValidator[] | any = [];
  private _errors: ValidationError[] = [];

  protected constructor(entry: ObjectModelEntry) {
    this.entry = entry;
  }

  get isValid(): boolean {
    return this.errors.length === 0;
  }

  get errors(): ValidationError[] {
    return this._errors;
  }

  validate() {
    const errors = [];
    const myError = this._validate();
    if (myError) errors.push(myError);
    for (const validator of this.validators) {      
      validator.validate();
      errors.push(...validator.errors);            
    }
    Vue.set(this, '_errors', errors);
  }

  protected abstract _validate(): ValidationError | null;
}

